export default {
  LIST (state, value) {
    state.list = value && Array.isArray(value) ? value : []
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push({
        id: value.id,
        name: value.name,
        users: value.users.length,
        permissions: value.permissions.length
      })
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, {
        id: value.id,
        name: value.name,
        users: value.users.length,
        permissions: value.permissions.length
      })
    }
  },
  CURRENT (state, value) {
    // need to make a more graceful update to minimize screen disruptions
    if (value) {
      for (const prop of ['id', 'name']) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
          state.update[prop] = value[prop]
        }
      }
      state.current.users = value.users ? value.users.map(u => {
        return {
          id: u.id,
          email: u.email,
          firstName: u.first_name,
          lastName: u.last_name
        }
      }) : []
      const actions = {}
      const permissions = value.permissions ? Object.values(value.permissions.reduce((res, perm) => {
        if (!res[perm.model]) {
          res[perm.model] = { model: perm.model }
        }
        res[perm.model][perm.action] = true
        actions[perm.action] = true
        return res
      }, {})) : {}
      state.current.permissions = permissions
      state.actions = Object.keys(actions)
    } else {
      state.current = {
        id: '',
        name: '',
        permissions: [],
        users: []
      }
      state.update = {
        id: '',
        name: ''
      }
      state.actions = []
    }
  },
  UPDATE_NAME (state, value) {
    state.update.name = value
  },
  USER_UPDATE (state, value) {
    const index = state.current.users.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.current.users.splice(index, 1, {
        id: value.id,
        email: value.email,
        firstName: value.firstName,
        lastName: value.lastName
      })
    }
  }
}
